import React from 'react'
import {Modal, FormGroup, FormControl} from 'react-bootstrap'
import CustomButton from './components/custom-task-button'
import Files from 'react-files'
import {submitCustomTask} from '../api'

export default React.createClass({
  getInitialState: function() {
    return {
        comment: '',
        selectedIndex: 0,
    }
  },
  toggleButton: function (index) {
    this.setState({
      selectedIndex: index
    })
    this.refs.btn0.setState({selected: index === 0})
    this.refs.btn1.setState({selected: index === 1})
    this.refs.btn2.setState({selected: index === 2})
  },
  handleInputChange: function (event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({[name]: value})
  },
  sendOrderToServer: function() {
    let frequency

    if(this.state.selectedIndex === 0) {
      frequency = "ONE_TIME"
    }
    else if(this.state.selectedIndex === 1) {
      frequency = "BIWEEKLY"
    }
    else if(this.state.selectedIndex === 2) {
      frequency = "WEEKLY"
    }

    submitCustomTask(this.state.comment, this.props.address, '', frequency).then((data) => {
    })
  },
  uploadPhoto: function() {

  },
   onFilesChange: function (files) {
  },

  onFilesError: function (error, file) {
  },
  render: function () {
    return (
      <div >
        <Modal show={this.props.show} onHide={this.props.hide}>
          <div className='concrete-gray-background'>
            <Modal.Header closeButton>
              <h2 className='text-center pull-down-xs-3'>{this.props.modalHeader}</h2>
              <h4 className='text-center pull-down-xs-2' style={{padding: '0 10px 0 10px', fontSize: '20px'}}>{this.props.modalSubHeader}</h4>
                <div className='row' style={{width:'90%', margin:'auto'}}>
                    <FormGroup className='center-block' style={{width:'85%'}}>
                    <FormControl className='faq-text' componentClass='textarea' name='comment' id='comment' value={this.state.comment} placeholder='Sprinkler repair? Pull a stump? Weed the flowerbeds? Fence repair? Our contractors can do anything!' onChange={this.handleInputChange} style={{height: 111, paddingTop: 20}}/>
              </FormGroup>
              </div>
              <p className='text-center' style={{marginBottom: '3px'}}><b>Select Frequency</b></p>
              <form>
                <div className='text-center' data-toggle='buttons' id='RadioGroup' style={{width:'60%', margin:'auto'}}>
                  <CustomButton classList='pull-left' imageRoot='ONE-TIME' handler={(i) => this.toggleButton(i)} index={0} ref='btn0' />
                  <CustomButton imageRoot='BIWEEKLY' handler={(i) => this.toggleButton(i)} index={1} ref='btn1' />
                  <CustomButton classList='pull-right'imageRoot='WEEKLY' handler={(i) => this.toggleButton(i)} index={2} ref='btn2' />
                </div>
              </form>
              <br />
              <p className='text-center'><b>Upload any applicable photos for your request:</b></p>
              <div className='text-center' style={{padding: '15px'}}>
                {/*<button type='file' ref='fileUploader' className='btn btn-info btn-sm' onClick={this.uploadPhotoButton}><i className='fa fa-camera' aria-hidden='true' style={{paddingRight: '7px'}} /><span className='small'>Upload photo</span></button>*/}
                <Files className='btn btn-info btn-sm' onChange={this.onFilesChange} onError={this.onFilesError} accepts={['image/png', 'text/plain', 'audio/*']} multiple maxFiles={3} maxFileSize={10000000} minFileSize={0} clickable>
                  <i className='fa fa-camera' aria-hidden='true' style={{paddingRight: '7px'}} /><span className='small'>Upload photo</span>
                </Files>
              </div>
            </Modal.Header>
            <Modal.Footer>
              <div className='text-center' style={{padding: '20px'}}>
                <button type='button' className='btn btn-sm btn-success' onClick={this.sendOrderToServer}>Submit Request</button>
              </div>
            </Modal.Footer>
          </div>
        </Modal>
      </div>

    )
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/custom-tasks-modal.jsx